import React, { FC } from 'react';

import { BetDetailsType } from '@legacyApp/types/bets/BetDetailsType';

import { KenoAutoBetNumberPanel } from '@modules/games/KenoGame/components/KenoNumberPanel/KenoAutoBetNumberPanel';
import { KenoNumberPanel } from '@modules/games/KenoGame/components/KenoNumberPanel/KenoNumberPanel';
import { KenoBetContext } from '@modules/games/KenoGame/context/KenoBet.context';

interface OptionalCurrencyBetDetailsType
	extends Omit<BetDetailsType, 'currency'> {
	currency?: string;
	hits?: number[];
}

interface KenoResultProps {
	data: OptionalCurrencyBetDetailsType;
	fullPanel?: boolean;
}

const KenoResult: FC<KenoResultProps> = ({ data, fullPanel }) => {
	return (
		<KenoBetContext.Provider
			value={{
				viewOnly: true,
				lockSelecting: true,
				selected: data?.selected,
				hits: data?.hits,
				risk: data?.risk,
			}}
		>
			<div className="w-full h-auto flex justify-center [.chat-wrapper_&]:justify-start">
				{fullPanel ? (
					<KenoNumberPanel
						className={`min_mobile_medium:!grid min_mobile_medium:!justify-center`}
						viewOnly
					/>
				) : (
					<KenoAutoBetNumberPanel viewOnly />
				)}
			</div>
		</KenoBetContext.Provider>
	);
};

export default KenoResult;
